import { accountConstants } from '../constants';

export function account(state = {}, action) {
  switch (action.type) {
    case accountConstants.GET_TYPE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_TYPE_SUCCESS:
      return {
        ...state, account_type: action.account_type
      }
    case accountConstants.GET_TYPE_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.GET_ALL_TYPE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_ALL_TYPE_SUCCESS:
      return {
        ...state, account_types: action.account_types
      }
    case accountConstants.GET_ALL_TYPE_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.GET_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_SUCCESS:
      return {
        ...state, account: action.account
      }
    case accountConstants.GET_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.GET_PROFILE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_PROFILE_SUCCESS:
      return {
        ...state, userprofile: action.userprofile
      }
    case accountConstants.GET_PROFILE_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.UPDATE_PROFILE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.UPDATE_PROFILE_SUCCESS:
      return {
        ...state, userprofile: action.userprofile
      }
    case accountConstants.UPDATE_PROFILE_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.GET_ALL_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_ALL_SUCCESS:
      return {
        ...state, accounts: action.accounts
      }
    case accountConstants.GET_ALL_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.GET_BY_CUSTOMER_ALL_REQUEST:
      return {
        loading: true
      };
    case accountConstants.GET_BY_CUSTOMER_ALL_SUCCESS:
      return {
        ...state, accounts: action.accounts
      }
    case accountConstants.GET_BY_CUSTOMER_ALL_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.RESET_PASSWORD_REQUEST:
      return {
        loading: true
      };
    case accountConstants.RESET_PASSWORD_SUCCESS:
      return {
        ...state
      };
    case accountConstants.RESET_PASSWORD_ERROR:
      return {
        error: action.error
      };
    case accountConstants.UPDATE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.UPDATE_SUCCESS:
      return {
        ...state, account: action.account
      };
    case accountConstants.UPDATE_FAILURE:
      return {
        error: action.error
      };
    case accountConstants.DELETE_REQUEST:
      return {
        loading: true
      };
    case accountConstants.DELETE_SUCCESS:
      return {
        ...state
      };
    case accountConstants.DELETE_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
